import { render, staticRenderFns } from "./StoragePlace.vue?vue&type=template&id=4f6a5243"
import script from "./StoragePlace.vue?vue&type=script&lang=js"
export * from "./StoragePlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports